import React from "react";
import {Box, Text} from "zmp-ui";
import {ListProduct} from "../cart/listProduct";
import {useRecoilValue} from "recoil";
import {totalPriceState, totalQuantityState} from "state";
import {formatMoney} from "component/display/price";
import {ProductItem} from "../../component/product/item";

export const ProductItems = ({mode, products}) => {
   const totalQuantity = useRecoilValue(totalQuantityState);
   const totalPrice = useRecoilValue(totalPriceState);
   return (
      <Box className={products.length === 0 ? "h-full" : ""}>
         {products.length > 0 ? (
            <Box className="product-block">
               <Box
                  flex
                  alignContent="center"
                  justifyContent="space-between"
                  style={{
                     fontSize: 18,
                     fontWeight: 600,
                     color: "#0F172A",
                     marginBottom: "24px",
                  }}
               >
                  <p className="product-block__title flex">
                     Thông tin sản phẩm
                     {/* (<span style={{ fontWeight: "400" }}>{products.length}</span>) */}
                  </p>
               </Box>
               <Box mb={6}>
                  {
                     products.map((item, i, list) => (
                        <ProductItem
                           list={list}
                           product={item}
                           onAmountChange={null}
                           onDelete={null}
                           page="cart"
                           mode={mode}
                        />
                     ))
                  }
               </Box>
               <Box>
                  <div
                     style={{
                        display: "flex",
                        justifyContent: "space-between",
                        height: "52px",
                     }}
                  >
                     <div
                        style={{
                           display: "grid",
                           justifyContent: "space-between",
                           height: "52px",
                        }}
                     >
                        {" "}
                        <Text fontSize={16}>Tổng số lượng</Text>
                        <Text style={{fontSize: 16, fontWeight: 600}}>Tổng cộng</Text>
                     </div>
                     <div
                        style={{
                           display: "grid",
                           justifyContent: "space-between",
                           height: "52px",
                        }}
                     >
                        <Text fontSize={16} style={{textAlign: "right"}}>
                           {totalQuantity}
                        </Text>
                        <Text style={{fontSize: 16, fontWeight: 600}}>
                           {formatMoney(totalPrice)}₫
                        </Text>
                     </div>
                  </div>
               </Box>
            </Box>
         ) : (
            <Box flex justifyContent="center" className="h-full pt-[130px]">
               <Box className="text-center pb-[48px]">
                  <Text
                     className="text-center text-gray"
                     bold={true}
                     size="large"
                     style={{color: "#0F172A"}}
                  >
                     Chưa có sản phẩm nào
                  </Text>

                  <Text
                     className="text-center text-gray"
                     bold={true}
                     size="small"
                     style={{color: "#64748B", paddingTop: "4px"}}
                  >
                     Chọn 1 sản phẩm để thêm vào giỏ hàng
                  </Text>

                  <Text
                     className="text-center text-gray"
                     bold={true}
                     size="small"
                     style={{color: "#64748B"}}
                  >
                     của bạn
                  </Text>
               </Box>
            </Box>
         )}
      </Box>
   );
};
